import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client
import fetch from "node-fetch";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Home
const GQLAddNeighborboundries = gql`
  mutation addneighborboundries(
    $geotype: String
    $name: String
    $areatype: String
    $label: String
    $level: String
    $neighborhoodtype: String
    $census_id: String
    $census_name: String
    $place_id: String
    $place_name: String
    $postalcity_id: String
    $postalcity_name: String
    $county_id: String
    $county_name: String
    $state_id: String
    $state_name: String
    $latitude: String
    $longitude: String
    $geometrytype: String
    $npi: Int
    $personal: Int
    $value: Int
    $school: Int
    $crime: Int
    $walkability: Int
    $publicspaces: Int
    $curb: Int
    $others: Int
    $geometry_cords: String
    $centroid: String
    $npiCityRanking: String
    $npiAreaRanking: String
    $reviewSummary: String
    $reviewOneLiner: String
    $keyword: String
    $similarneighborhoodIds: String
  ) {
    createneighborboundries(
      geotype: $geotype
      name: $name
      areatype: $areatype
      label: $label
      level: $level
      neighborhoodtype: $neighborhoodtype
      census_id: $census_id
      census_name: $census_name
      place_id: $place_id
      place_name: $place_name
      postalcity_id: $postalcity_id
      postalcity_name: $postalcity_name
      county_id: $county_id
      county_name: $county_name
      state_id: $state_id
      state_name: $state_name
      latitude: $latitude
      longitude: $longitude
      geometrytype: $geometrytype
      npi: $npi
      personal: $personal
      value: $value
      school: $school
      crime: $crime
      walkability: $walkability
      publicspaces: $publicspaces
      curb: $curb
      others: $others
      geometry_cords: $geometry_cords
      centroid: $centroid
      npiCityRanking: $npiCityRanking
      npiAreaRanking: $npiAreaRanking
      reviewSummary: $reviewSummary
      reviewOneLiner: $reviewOneLiner
      keyword: $keyword
      similarneighborhoodIds: $similarneighborhoodIds
    ) {
      success
      message
    }
  }
`;

//Update Home
const GQLUpdateneighborboundries = gql`
  mutation updateneighborboundries($id: String!, $name: String) {
    Updateneighborboundries(id: $id, name: $name) {
      success
      message
    }
  }
`;

//Delete Home
const GQLneighborboundries = gql`
  mutation deleteneighborboundries($id: String!) {
    deleteneighborboundries(id: $id) {
      success
      message
    }
  }
`;

const QUERY_getneighborhoodImages = gql`
  query getNeighborhoodImages(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getneighborhoodImages(
      start: $start
      limit: $limit
      order: $order
      orderBy: $orderBy
      fields: $fields
    ) {
      id
      imageurl
      neighborhoodId
      img_id
    }
  }
`;

const QUERY_getSchoolinNh = gql`
  query getSchoolinNh(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $zoomLevel: Int
  ) {
    getSchoolinNh(
      start: $start
      limit: $limit
      order: $order
      orderBy: $orderBy
      fields: $fields
      zoomLevel: $zoomLevel
    ) {
      id
      CDSCode
      County
      District
      School
      StreetAbr
      City
      State
      PhoneNumber
      Website
      GSserved
      Boundary
      SchoolLat
      SchoolLong
      NumberofStudents
      StudentRatio
      GreatSchoolsRating
      AcademicProgressCollegeReadiness
      TestScores
      EquityReview
      latlangs
      greatschoolurl
    }
  }
`;

const GQLUpdatekeywordsummary = gql`
  mutation updatekeywordsummary($neighborhoodid: String, $id: String) {
    updatekeywordsummary(neighborhoodid: $neighborhoodid, id: $id) {
      success
      message
    }
  }
`;

const GQLUpdatekeywordsummarydata = gql`
  mutation updatekeywordsummarydata($neighborhoodid: String, $id: String) {
    updatekeywordsummarydata(neighborhoodid: $neighborhoodid, id: $id) {
      success
      message
    }
  }
`;

const QUERY_getKeywordsummary = gql`
  query getKeywodSummary(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getKeywodSummary(
      start: $start
      limit: $limit
      order: $order
      orderBy: $orderBy
      fields: $fields
    ) {
      id
      NeighborhoodID
      UserID
      author
      createDate
      helpfulCount
      heading
      description
      communityRating
      publicSpacesRating
      curbAppealRating
      jobsRating
      keywords
      helpStatus
      greatfor
      editor_rate
      summary
      isdisplay
      userDetails {
        id
        type
        firstName
        lastName
        email
        password
        aboutMe
        numberNeighborhoodsReviewed
        likes
        questionsAnswered
        points
        realEstateFirm
        license
        phone
        aboutMe
        isagent
        ishomebuyer
        ishomeseller
        isneighbor
        istopagent
        userimage
      }
    }
  }
`;
//Get All Home

//   id
//   geometry_cords
//   name
//   npi
//   personal
//   value
//   school
//   crime
//   walkability
//   community
//   curb
//   others
//   postalcity_name
//   label
//   census_name
//   place_name
//   postalcity_id
//   county_name
//   state_name
//   latitude
//   longitude
//   npiCityRanking
//   npiAreaRanking
//   reviewSummary
//   reviewOneLiner
//   keyword
//   similarneighborhoodIds
//   neighborhoodImages{
//     neighborhoodId
//     imageurl
//     img_id
//   }
//   similarneighborhoodIds_list{
//     id
//     name
//     label
//     npi
//     value
//     reviewOneLiner
//     neighborhoodImages{
//       neighborhoodId
//       imageurl
//       img_id
//     }
//   }
// }

const QUERY_getneighborboundrieslist = gql`
  query getneighborboundries(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $userid: String
    $userdata: String
    $schools: Float
    $safety: Float
    $walkability: Float
    $publicspaces: Float
    $curbAppeal: Float
    $valueindex: Float
    $minprice: Float
    $maxprice: Float
    $current_tab: String
    $zoomLevel: Int
  ) {
    getneighborboundries(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
      userid: $userid
      userdata: $userdata
      schools: $schools
      safety: $safety
      walkability: $walkability
      publicspaces: $publicspaces
      curbAppeal: $curbAppeal
      valueindex: $valueindex
      minprice: $minprice
      maxprice: $maxprice
      current_tab: $current_tab
      zoomLevel: $zoomLevel
    ) {
      id
      appreciation
      geometry_cords
      name
      npi
      personal
      value
      school
      crime
      walkability
      publicspaces
      curb
      others
      amenities
      postalcity_name
      latitude
      longitude
      walkscorestatus
      state_name
      primaryschoolscore
      middleschoolscore
      highschoolscore
      medianprice
      personalNpi
      census_name
      label
      nhfullname
      cityfullname
      valuescore_city
      savedneighbor {
        id
        neighborhoodId
        userId
        name
        city
        state
        savedStatus
      }
      neighborhoodImages {
        imageurl
        thumbnailurl
      }
      cityImages {
        imageurl
      }
      cityaverage {
        totalnpi
        npisore
        personalscore
        valuescore
        schoolscore
        crimescore
        walkscore
        comscore
        crubscore
        otherscore
        medianpricescore
        primaryscore
        middlescore
        highscore
      }
      nhsummary {
        summary
      }
    }
  }
`;

const QUERY_getnhmapneighborboundrieslist = gql`
  query getnhmapneighborboundries(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $userid: String
    $userdata: String
    $schools: Float
    $safety: Float
    $walkability: Float
    $publicspaces: Float
    $curbAppeal: Float
    $valueindex: Float
    $minprice: Float
    $maxprice: Float
    $current_tab: String
    $zoomLevel: Int
    $device: String
  ) {
    getnhmapneighborboundries(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
      userid: $userid
      userdata: $userdata
      schools: $schools
      safety: $safety
      walkability: $walkability
      publicspaces: $publicspaces
      curbAppeal: $curbAppeal
      valueindex: $valueindex
      minprice: $minprice
      maxprice: $maxprice
      current_tab: $current_tab
      zoomLevel: $zoomLevel
      device: $device
    ) {
      id
      name
      label
      geometry_cords
      latitude
      longitude
      npi
      personal
      value
      school
      crime
      walkability
      publicspaces
      curb
      others
      amenities
      postalcity_name
      state_name
      medianprice
      primaryschoolscore
      middleschoolscore
      highschoolscore
      totalnpi_city
      medianpricescore_city
      primaryschoolscore_city
      middleschoolscore_city
      npiscore_city
      personalscore_city
      valuescore_city
      schoolscore_city
      crimescore_city
      walkscore_city
      highschoolscore_city
      imageurl
      thumbnailurl
      cityimages
      cityreview
      summary
      savedneighborhoodbyuser
      personalNpi
      appreciation
      dom
      is_display_prod
      is_display_dev
      nhfullname
      cityfullname
    }
  }
`;

const QUERY_getneighborhoodcount = gql`
  query getneighborhoodcount(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $userid: String
  ) {
    getneighborhoodcount(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
      userid: $userid
    ) {
      totalcount
    }
  }
`;

const QUERY_getDetailsNhBoundries = gql`
  query getDetailsNhBoundries(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $userId: String
  ) {
    getDetailsNhBoundries(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
      userId: $userId
    ) {
      id
      geometry_cords
      name
      npi
      personal
      value
      school
      crime
      walkability
      publicspaces
      curb
      others
      amenities
      postalcity_name
      label
      census_name
      place_name
      postalcity_id
      county_name
      state_name
      latitude
      longitude
      npiCityRanking
      npiAreaRanking
      reviewSummary
      reviewOneLiner
      keyword
      similarneighborhoodIds
      primaryschoolscore
      middleschoolscore
      highschoolscore
      medianprice
      npiscore_city
      schoolscore_city
      crimescore_city
      medianpricescore_city
      valuescore_city
      cityimage
      similarneighborhoodIds_list {
        id
        name
        label
        npi
        value
        reviewOneLiner
      }
      neighborhoodImages {
        id
        neighborhoodId
        imageurl
        img_id
        user_id
        caption
        photocategory
        date
        username
        userrole
        rate
        imagehelpfulcount
        helpedUserId
        helpStatus
        userimage
        listingby
      }
      dom
      appreciation
      walkscorestatus
      medianPriceDomCityFlag
      appreciationCityFlag
      monthlyMedianPrice
      monthlyMedianPriceLastMonth
      schools_in_nh
      is_display_prod
      is_display_dev
      nhfullname
      cityfullname
      appreciation_city
      cityMedianPrice
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Home Function

async function addneighborboundries(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddNeighborboundries,
        variables: {
          geotype: adddata.geotype,
          id: adddata.id,
          name: adddata.name,
          areatype: adddata.areatype,
          label: adddata.label,
          level: adddata.level,
          neighborhoodtype: adddata.neighborhoodtype,
          census_id: adddata.census_id,
          census_name: adddata.census_name,
          place_id: adddata.place_id,
          place_name: adddata.place_name,
          postalcity_id: adddata.postalcity_id,
          postalcity_name: adddata.postalcity_name,
          county_id: adddata.county_id,
          county_name: adddata.county_name,
          state_id: adddata.state_id,
          state_name: adddata.state_name,
          latitude: adddata.latitude,
          longitude: adddata.longitude,
          geometrytype: adddata.geometrytype,
          npi: adddata.npi,
          personal: adddata.personal,
          value: adddata.value,
          school: adddata.school,
          crime: adddata.crime,
          walkability: adddata.walkability,
          publicspaces: adddata.publicspaces,
          curb: adddata.curb,
          others: adddata.others,
          geometry_cords: adddata.geometry_cords,
          centroid: adddata.centroid,
          npiCityRanking: adddata.npiCityRanking,
          npiAreaRanking: adddata.npiAreaRanking,
          reviewSummary: adddata.reviewSummary,
          reviewOneLiner: adddata.reviewOneLiner,
          keyword: adddata.keyword,
          similarneighborhoodIds: adddata.similarneighborhoodIds,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updateneighborboundries(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateneighborboundries,
        variables: {
          id: updatedata.id,
          propertyType: updatedata.propertyType,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deleteneighborboundries(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLneighborboundries,
        variables: {
          id: deletedataId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllneighborboundrieslist(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getneighborboundrieslist,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          userid: getdata.userid,
          userdata: getdata.userdata,
          schools: getdata.schools,
          safety: getdata.safety,
          walkability: getdata.walkability,
          publicspaces: getdata.publicspaces,
          curbAppeal: getdata.curbAppeal,
          valueindex: getdata.valueindex,
          minprice: getdata.minprice,
          maxprice: getdata.maxprice,
          current_tab: getdata.current_tab,
          zoomLevel: getdata.zoomLevel,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Get list by own query
async function getnhmapneighborboundrieslist(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getnhmapneighborboundrieslist,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          userid: getdata.userid,
          userdata: getdata.userdata,
          schools: getdata.schools,
          safety: getdata.safety,
          walkability: getdata.walkability,
          publicspaces: getdata.publicspaces,
          curbAppeal: getdata.curbAppeal,
          valueindex: getdata.valueindex,
          minprice: getdata.minprice,
          maxprice: getdata.maxprice,
          current_tab: getdata.current_tab,
          zoomLevel: getdata.zoomLevel,
          device: getdata.device,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getNeighborhoodcount(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getneighborhoodcount,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          userid: getdata.userid,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getDetailsNhboundrieslist(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getDetailsNhBoundries,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          userId: getdata.userId,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// Get list of neighborhood images
async function getneighborhoodImages(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getneighborhoodImages,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updatekeywordsummary(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdatekeywordsummary,
        variables: {
          id: updatedata.id,
          // keyword:updatedata.keyword,
          // reviewSummary:updatedata.reviewSummary
          neighborhoodid: updatedata.neighborhoodid,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updatekeywordsummarydata(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdatekeywordsummarydata,
        variables: {
          id: updatedata.id,
          neighborhoodid: updatedata.neighborhoodid,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getSchoolinNh(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getSchoolinNh,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          zoomLevel: getdata.zoomLevel,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getKeywodSummary(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getKeywordsummary,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          userId: getdata.userId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addneighborboundries,
  updateneighborboundries,
  deleteneighborboundries,
  getAllneighborboundrieslist,
  getDetailsNhboundrieslist,
  getneighborhoodImages,
  updatekeywordsummary,
  getSchoolinNh,
  getKeywodSummary,
  updatekeywordsummarydata,
  getNeighborhoodcount,
  getnhmapneighborboundrieslist,
};
